export interface IGRATUITY_FORMULA {
  salary: number;
  noOfYears: number;
}
export const GRATUITY_FORMULA = ({ salary, noOfYears }: IGRATUITY_FORMULA) => {
  if (salary < 1 || salary > 1e10) {
    const gratuity = 0;
    return {
      totalGratuity: gratuity.toFixed(2),
    };
  }
  const sal = salary;
  const years = noOfYears;

  const gratutity = Math.round((sal * years * 15) / 26);
  return {
    totalGratuity: gratutity.toFixed(2),
  };
};
